import { parseQueryString } from 'alto-utils/lib/utils'

export withAuthMessage = (url, message, messageType = 'info') ->
  url + (if message then "?message=#{message}&message_type=#{messageType}" else '')

export authMessageFromQS = (qs) ->
  { message, message_type } = parseQueryString(qs)

  { message, messageType: message_type }
